export function getMajorVersion(version) {
    return Number(version.split('.')[0]);
}
